import job_search_split_screen_0 from "file:///home/wldocker/wl-cms/sites/modules/job-search-split-screen-widget/ui/src/job-search-split-screen.js";



import job_search_split_screen_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/job-search-split-screen-widget/ui/src/job-search-split-screen.scss";job_search_split_screen_0();